'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var Button = require('./Button');
var Spinner = require('./Spinner');

var FileUpload = (function (_React$Component) {
    _inherits(FileUpload, _React$Component);

    function FileUpload(props) {
        _classCallCheck(this, FileUpload);

        _get(Object.getPrototypeOf(FileUpload.prototype), 'constructor', this).call(this, props);
        this.displayName = 'FileUpload';
        this.ref = null;
        this.state = {
            file: {}
        };
    }

    _createClass(FileUpload, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.ref && this.ref.addEventListener('click', function () {
                this.value = '';
            }, false);
        }
    }, {
        key: 'triggerFileBrowser',
        value: function triggerFileBrowser() {
            this.ref && this.ref.click();
        }
    }, {
        key: 'handleChange',
        value: function handleChange(event) {
            var self = this;
            self.props.onChange ? self.props.onChange(event.target.files) : null;
        }

        // cancelUpload() {
        //     this.setState({
        //         dataURI: false,
        //         file: {},
        //     });
        // }

    }, {
        key: 'render',
        value: function render() {
            var _this = this;

            // props
            var props = (0, _blacklist2['default'])(this.props, 'children', 'file', 'onChange');

            // elements
            // var component = (
            //     <Button
            //         onClick={this.triggerFileBrowser.bind(this)}
            //         disabled={this.props.disabled || this.state.loading}
            //     >
            //         {this.state.loading && <Spinner />}{this.props.buttonLabelInitial}
            //     </Button>
            // );

            // if (dataURI) {
            //     component = (
            //         <div className="FileUpload">
            //             <div className="FileUpload__image">
            //                 <img className="FileUpload__image-src" src={dataURI} />
            //             </div>
            //             <div className="FileUpload__content">
            //                 <div className="FileUpload__message">
            //                     {file.name} ({Math.round(file.size / 1024)}Kb)
            //                 </div>
            //                 <div className="FileUpload__buttons">
            //                     <Button onClick={this.triggerFileBrowser.bind(this)} disabled={this.state.loading}>
            //                         {this.state.loading && <Spinner />}
            //                         {this.props.buttonLabelChange}
            //                     </Button>
            //                     <Button
            //                         onClick={this.cancelUpload.bind(this)}
            //                         type="link-cancel"
            //                         disabled={this.state.loading}
            //                     >
            //                         Cancel
            //                     </Button>
            //                 </div>
            //             </div>
            //         </div>
            //     );
            // }

            return _react2['default'].createElement(
                'div',
                null,
                this.props.children ? _react2['default'].cloneElement(this.props.children, { onClick: this.triggerFileBrowser.bind(this) }) : null,
                _react2['default'].createElement('input', _extends({
                    style: { display: 'none' },
                    type: 'file',
                    ref: function (ref) {
                        _this.ref = ref;
                    },
                    onChange: this.handleChange.bind(this)
                }, props))
            );
        }
    }]);

    return FileUpload;
})(_react2['default'].Component);

FileUpload.propTypes = {
    file: _propTypes2['default'].object, // https://developer.mozilla.org/en/docs/Using_files_from_web_applications
    onChange: _propTypes2['default'].func
};

module.exports = FileUpload;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/FileUpload.js
// module id = 300
// module chunks = 0